import React, { useState } from 'react';
import { setupAdmin } from './api';

function SetupPage({ onSetupComplete }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await setupAdmin(username, password, email);
      onSetupComplete();
    } catch (err) {
      setError(err.response?.data?.detail || 'Setup failed');
    }
  };

  return (
    <div className="container" style={{ maxWidth: 400, marginTop: '10vh' }}>
      <div className="card">
        <h2 className="text-center">Initial Setup</h2>
        <p className="text-center" style={{ color: 'var(--text-secondary)' }}>Create your admin account</p>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem' }}>Username</label>
            <input className="input" style={{ width: '100%' }} value={username} onChange={e => setUsername(e.target.value)} required />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem' }}>Email</label>
            <input className="input" style={{ width: '100%' }} type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem' }}>Password</label>
            <input className="input" style={{ width: '100%' }} type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          {error && <div style={{ color: 'var(--danger)', marginBottom: '1rem' }}>{error}</div>}
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>Create Admin</button>
        </form>
      </div>
    </div>
  );
}

export default SetupPage;
